import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';

export default React.createClass({
  mixins: [PureRenderMixin],
  render() {
    return <div style={{float: this.props.to}}>{this.props.children}</div>;
  }
});
